export enum MeasureTypeKind {
  SECURITY_TYPE = 'SECURITY_TYPE',
  CONTROL_TYPE = 'CONTROL_TYPE',
}
